import { module as ModuleJS } from "modujs";
import MicroModal from "micromodal";

const MODAL_ID = "post-modal";
const config = {
    openClass: "is-open",
    disableScroll: true,
    disableFocus: true,
    awaitOpenAnimation: false,
    awaitCloseAnimation: false,
};

const LOADER =
    '<div class="post-modal__loader">' +
    '<span class="post-modal__spinner" role="status" aria-label="Chargement en cours"></span>' +
    "</div>";

/**
 * Ouvre l'aperçu d'un produit dans la modale partagée #post-modal.
 *
 * Le contenu est récupéré à la demande via admin-ajax (action `so_modal`),
 * qui ne renvoie que des produits publiés. Aucun endpoint arbitraire :
 * on remplace ainsi le plugin wp-post-modal tout en gardant le lazy-load.
 *
 * Déclencheur attendu :
 *   <a data-module-modal-post data-modal-post-id="123" href="/fallback/">…</a>
 */
export default class extends ModuleJS {
    constructor(m) {
        super(m);
        this.open = this.open.bind(this);
    }

    init() {
        this.el.addEventListener("click", this.open);
    }

    async open(e) {
        e.preventDefault();

        const id = this.getData("id");
        if (!id) return;

        const box = document.getElementById("post-modal-content");
        if (!box) return;

        box.innerHTML = LOADER;
        MicroModal.show(MODAL_ID, config);

        const data = (typeof window !== "undefined" && window.soData) || {};
        const url =
            (data.ajaxUrl || "/wp-admin/admin-ajax.php") +
            "?action=so_modal&id=" +
            encodeURIComponent(id) +
            "&nonce=" +
            encodeURIComponent(data.nonce || "");

        try {
            const res = await fetch(url, { credentials: "same-origin" });
            const json = await res.json();

            if (!res.ok || !json || !json.success) {
                throw new Error("unavailable");
            }

            box.innerHTML = json.data.html;
        } catch (err) {
            box.innerHTML =
                '<p class="post-modal__error">Contenu indisponible pour le moment.</p>';
        }
    }

    destroy() {
        this.el.removeEventListener("click", this.open);
    }
}
